module.exports = __webpack_public_path__ + "img/box07_01.a308af35.png";